import { useEmailHealth } from '../../providers/EmailHealthProvider';
import { Loader2, Mail } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function EmailHealthFloatingProgress() {
  const { runAllLoading, runAllProgress } = useEmailHealth();
  const location = useLocation();
  const navigate = useNavigate();

  // Don't show on the Email Health page itself (it has its own progress bar)
  if (!runAllLoading || !runAllProgress || location.pathname === '/email-health') return null;

  const pct = Math.round((runAllProgress.current / runAllProgress.total) * 100);

  return (
    <div
      onClick={() => navigate('/email-health')}
      className="fixed bottom-4 right-4 z-50 cursor-pointer rounded-xl border border-primary-500/30 bg-card shadow-lg p-3 w-72 space-y-2 hover:border-primary-500/60 transition-colors"
    >
      <div className="flex items-center gap-2 text-sm">
        <div className="relative">
          <Mail className="h-4 w-4 text-primary-600 dark:text-primary-400" />
          <Loader2 className="h-3 w-3 animate-spin text-primary-500 absolute -top-1 -right-1" />
        </div>
        <span className="font-medium text-foreground">Email Health Check</span>
        <span className="ml-auto text-xs text-muted-foreground">{runAllProgress.current}/{runAllProgress.total}</span>
      </div>
      <div className="w-full bg-muted rounded-full h-1.5">
        <div
          className="bg-primary-600 h-1.5 rounded-full transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="text-xs text-muted-foreground truncate">{runAllProgress.clientName}</div>
    </div>
  );
}
